import { useNavigate } from "react-router-dom";
import { Button, ButtonDisabled } from "shared/components/Button";
import Refresh from "shared/components/Refresh";
import Search from "shared/components/Search";
import styled from "styled-components";
import useBranchListView from "features/owner/hooks/useBranchListView";
import { hw, scrollbar } from "features/homework/homeworkUi";

interface ListViewProps{
    clickedItem:string,
    setClickedItem:React.Dispatch<React.SetStateAction<string>>
}

const BranchListView = ({clickedItem, setClickedItem}:ListViewProps)  => {
    const navigate = useNavigate();
    const {searchedLists, onChange, search, onRefreshClick} = useBranchListView();
    const showList = () => {
        if (!searchedLists.length) {
            return <Empty>{search ? "검색 결과가 없습니다." : "등록된 지점이 없습니다."}</Empty>;
        }
        return searchedLists.map((item) => {
            const itemId = item.uid || item.id;
            return (
                <Item
                    key={itemId}
                    $active={itemId === clickedItem}
                    onClick={() => setClickedItem(itemId)}
                >
                    {item.name}
                </Item>
            );
        })
    }
    return(
        <Container>
            <Header>
                <div>
                    <Title>지점 목록</Title>
                    <Sub>지점명을 눌러 계정을 선택하세요.</Sub>
                </div>
                <Refresh onRefreshClick={onRefreshClick}/>
            </Header>
            <Search placeholder="지점명을 입력해 주세요" value={search} onChange={onChange}/>
            <List>
                {showList()}
            </List>
            <Buttons>
                {clickedItem ? <ButtonDisabled name="수정하기" onButtonClick={() => navigate("register", {state:clickedItem})}/> : null}
                <Button name="생성하기" onButtonClick={() => navigate("register")}/>
            </Buttons>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 14px;
    min-width: 0;
    min-height: 0;
    height: 100%;
    padding: 20px 18px 16px;
    background: ${hw.surface};
    border: 1px solid ${hw.border};
    border-radius: 16px;
    box-shadow: ${hw.shadow};
`
const List = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    border-radius: 12px;
    border: 1px solid ${hw.border};
    background: ${hw.surface};
    overflow-y: auto;
    overflow-x: hidden;
    ${scrollbar}
`

const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    gap: 12px;
    padding-bottom: 12px;
    border-bottom: 1px solid ${hw.border};
    flex-shrink: 0;
`

const Title = styled.h2`
    margin: 0;
    color: ${hw.text};
    font-size: 16px;
    font-weight: 700;
    letter-spacing: -0.02em;
`

const Sub = styled.p`
    margin: 4px 0 0;
    font-size: 13px;
    color: ${hw.textMuted};
`

const Buttons = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    padding-top: 12px;
    border-top: 1px solid ${hw.border};
    flex-shrink: 0;
`

const Item = styled.div<{ $active?: boolean }>`
    padding: 14px 16px;
    border-bottom: 1px solid ${hw.border};
    color: ${props => props.$active ? hw.brand : hw.text};
    background: ${props => props.$active ? hw.brandSoft : "transparent"};
    font-size: 15px;
    font-weight: ${props => props.$active ? 700 : 500};
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease;

    &:hover {
        background: ${props => props.$active ? hw.brandSoft : hw.bg};
        color: ${hw.text};
    }
`

const Empty = styled.div`
    padding: 36px 16px;
    text-align: center;
    color: ${hw.textSubtle};
    font-size: 13px;
`

export default BranchListView;
